define([
    'ko'
], (ko) => {
    'use strict';

    /**
     * @param {string} haystack containing string
     * @param {string} needle contained string
     * @returns {boolean} is needle inside haystack
     */
    function stringContainsString (haystack, needle) {
        return haystack.indexOf(needle) !== -1;
    }

    class MiniSearchForm {

        /** @type {Object} */
        config = {
            autocomplete: 'off',
            minSearchLength: 3,
            suggestionDelay: 300,
            suggestionBaseUrl: null,
            resultUrl: null
        };

        searchQuery;

        submitDisabled;

        #suggestions;

        filteredSuggestions;

        suggestionUrl;

        suggestionsLength;

        lastQuery;

        /**
         * @param {Object} config configuration
         */
        constructor (config) {
            Object.assign(this.config, config);
            let searchQuery = ko.observable('');
            this.searchQuery = ko.pureComputed({
                read: function () {
                    return searchQuery();
                },
                write: function (value) {
                    searchQuery(value.toLowerCase());
                },
                owner: this
            });
            this.submitDisabled = ko.observable(true);
            this.#suggestions = ko.observableArray([]);
            this.filteredSuggestions = ko.pureComputed(() => {
                const query = this.searchQuery();
                return this.#suggestions().filter(
                    suggestion => stringContainsString(suggestion.title, query)
                );
            });
            this.suggestionUrl = ko.observable('');
            this.suggestionsLength = ko.pureComputed(() => this.#suggestions().length);
            this.lastQuery = '';

            // only notify subscribers that suggestionUrl has changed if "suggestionDelay" has elapsed without changes
            this.suggestionUrl.extend({
                rateLimit: {
                    method: "notifyWhenChangesStop",
                    timeout: this.config.suggestionDelay
                }
            });

            this.searchQuery.subscribe(this.onQueryChange.bind(this));
            this.suggestionUrl.subscribe(async url => {
                this.lastQuery = this.searchQuery();
                this.#suggestions(
                    (await (await fetch(url)).json()).map(suggestion => ({
                        title: suggestion.title.toLowerCase(),
                        num_results: suggestion.num_results
                    }))
                );
            });
        }

        /**
         * @param {string} value search input value
         */
        onQueryChange (value) {
            this.submitDisabled(true);
            if (value.length < parseInt(this.config.minSearchLength, 10)) {
                this.#suggestions([]);
                return;
            }
            if (!stringContainsString(value, this.lastQuery) && !stringContainsString(this.lastQuery, value)) {
                this.#suggestions([]);
            }
            this.submitDisabled(false);
            if (!this.config.suggestionBaseUrl || this.config.suggestionBaseUrl.length === 0) {
                return;
            }

            this.suggestionUrl(`${this.config.suggestionBaseUrl}?q=${encodeURIComponent(value)}`);
        }

        /**
         * @param {string} suggestion text
         * @returns {string} search result URL for suggestion
         */
        getSuggestionHref (suggestion) {
            return `${this.config.resultUrl}?q=${encodeURIComponent(suggestion)}`;
        }

        /**
         * @param {string} suggestion search suggestion
         * @returns {string} suggestion html
         */
        getSuggestionHtml (suggestion) {
            const searchQuery = this.searchQuery();
            return `${suggestion.replace(searchQuery, `<span class="query-text">${searchQuery}</span>`)}`;
        }
    }

    return MiniSearchForm;
});
